window.onresize = function(){
    document.documentElement.style.fontSize = document.documentElement.clientWidth/7.5 + 'px'
}
document.documentElement.style.fontSize = document.documentElement.clientWidth/7.5 + 'px'